import api from './client'

/**
 * Promociones del storefront — toggle activo/pausado.
 *
 * Las REGLAS (subrubro, NxM, descuento) viven hardcoded en el código del
 * storefront (`ligier-store/src/lib/promotions.ts`). Esta API solo controla
 * el flag `active` que el storefront usa para filtrar qué promos aplicar.
 */
export const promocionesApi = {
  listar: () => api.get('/promociones'),
  toggle: (slug) => api.patch(`/promociones/${slug}/toggle`),
}
